import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { RadioContainer, RollingLoader, ToggleSwitch } from "../../commons";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
import { RadioTypes } from "../../../commonTypes/universalTypes";


type AppProps = {
  showAddEditMasterDataModal: boolean;
  isEdit: boolean;
  handleAddAndUpdate: () => void;
  handleInputChange: (data: any) => void;
  toggleAddEditMasterDataModal: () => void;
  inputFieldName: string;
  inputFieldError: string;
  fieldLabel: string;
  AddButtonName: string;
  UpdateButtonName: string;
  handleToogleStatusChange?: () => void;
  status: boolean;
  inputUniqueCheck?: number | null;
  fetching?: boolean;
  modalHeader?:string;
  toggleStatus?:boolean;
  UniqueCheckErrorMessage?:string;
  type?:string;
  handleSetRadioValue?: (id: string) => void;
  invoiceType?: string;
  radioOptions?: RadioTypes[];
};

const AddEditMasterModuleModal = ({
  showAddEditMasterDataModal,
  toggleAddEditMasterDataModal,
  isEdit,
  inputFieldName,
  inputFieldError,
  handleAddAndUpdate,
  handleInputChange,
  handleToogleStatusChange,
  status,
  fieldLabel,
  UpdateButtonName,
  AddButtonName,
  inputUniqueCheck,
  fetching,
  modalHeader,
  toggleStatus,
  UniqueCheckErrorMessage,
  type,
  handleSetRadioValue,
  invoiceType,
  radioOptions,
}: AppProps) => {
  return (
    <Modal
      isOpen={showAddEditMasterDataModal}
      toggle={toggleAddEditMasterDataModal}
    >
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} ${modalHeader}`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="form-group mt-3">
            <div>
              <label
                htmlFor="foldername"
                className={inputFieldName ? "active" : ""}
              >
                {fieldLabel} <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                {type=="scopeOfWork" ? (
                  <textarea
                  className={`form-control ${inputFieldError ? "error-border" : ""}`}
                  name="text"
                  value={inputFieldName}
                  autoFocus
                  onChange={(e) => handleInputChange(e)}
                  // maxLength={60}
                  onKeyPress={(e) =>
                      e.key === "Enter" ? handleAddAndUpdate() : null
                  }
              />
                ):
                <input
                type={"text"}
                className={`form-control ${
                  !!inputFieldError ? "error-border" : null
                }`}
                name="text"
                value={inputFieldName}
                autoFocus
                onChange={(e) => handleInputChange(e)}
                maxLength={60}
                onKeyPress={(e: any) =>
                  e.key === "Enter" ? handleAddAndUpdate() : null
                }
              />
                }
               
                {fetching && <RollingLoader />}
              </div>
              {inputUniqueCheck === 1 && (
                <small className="text-danger">
                  {UniqueCheckErrorMessage}
                </small>
              )}
            </div>
            {type!=="scopeOfWork" ? 
            <span className="input-length">
              {returnInputFieldLength(inputFieldName?.length, 60)}
            </span>:''}
          </div>
          <div>
            {/* <div className="ml-4"> */}
            {type == "pdfTemplate" && handleSetRadioValue && invoiceType && radioOptions &&(
              <RadioContainer
              optionsList={radioOptions}
              handleSetRadioValue={handleSetRadioValue}
              radioValue={invoiceType}
              alignment="horizontal"
              />
            )}
              
            {/* </div> */}
          </div>
          {/* Future use */}
          {toggleStatus &&
          <div className="row">
            <div className="col-md-4 form-group mt-3">
              <label htmlFor="Job Status" className="mb-2">
                Status
              </label>
              <ToggleSwitch
                handleToggleChange={() => handleToogleStatusChange?.()}
                isChecked={status}
              />
            </div>
          </div>
}
        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddEditMasterDataModal}>
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleAddAndUpdate();
            toggleAddEditMasterDataModal();
          }}
          disabled={
            inputFieldName?.trim().length === 0 || inputUniqueCheck === 1
          }
        >
          {isEdit ? UpdateButtonName : AddButtonName}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditMasterModuleModal;
